"use client";

import { Splash } from "@/components/Splash/Splash";
import { useTheme } from "@/hooks/useTheme";
import { useRouters } from "@cloudspire/shared/hooks/useRouters";
import { FormattedMessage } from "react-intl";

export function DataHandlerNoResult() {
  const { nextjsAccountRouter } = useRouters();

  const { theme } = useTheme();

  return (
    <Splash
      title={<FormattedMessage defaultMessage="404" />}
      description={
        <FormattedMessage defaultMessage="La ressource demandée n’a pas été trouvée." />
      }
      src={nextjsAccountRouter.getUrl({
        id: "@account-v2/assets",
        parameters: {
          resource: `/assets/splashes/no-result/${theme}.svg`,
        },
      })}
    />
  );
}
